// 子仓库 - 企微管理
import to from 'await-to-js';
import * as apis from "@/api/interface/wecom";

export default {
  namespaced: true,
  state: () => ({
    userList: undefined, //短险监控所属期 - 列表
  }),
  getters: {},
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
  },
  actions: {
    // 获取企微对应公司主体
    async getCompanyBodyOptions(_ctx, payload = {}) {
      const [, res] = await to (apis.getCompanyBodyOptions(payload));
      return res;
    },
    // 获取枚举选项
    async enumOptions(_ctx, payload = {}) {
      const [, res] = await to (apis.enumOptions(payload));
      return res;
    },
    // 用户管理 - 列表
    async getUserList(ctx, payload = {}) {
      const [err, res] = await to (apis.getUserList(payload));
      ctx.commit("update", {
        userList: !err && res.data ? res.data : undefined,
      });
    },
    // 用户管理 - 导出
    async exportUserList(_ctx, payload = {}) {
      const [, res] = await to (apis.exportUserList(payload));
      return res;
    },
    // 用户管理 - 新增、修改
    async userAddOrUpdate(_ctx, payload = {}) {
      const [, res] = await to(apis.userAddOrUpdate(payload));
      return res;
    },
    // 用户管理 - 拉取圈量数据
    async pullJingyuData(_ctx, payload = {}) {
      const [, res] = await to(apis.pullJingyuData(payload));
      return res;
    },
    // 用户管理 - 新增主体
    async companyAdd(_ctx, payload = {}) {
      const [, res] = await to(apis.companyAdd(payload));
      return res;
    },
    // 用户管理 - 确认录音是否核准通过
    async voiceCheck(_ctx, payload = {}) {
      const [, res] = await to(apis.voiceCheck(payload));
      return res;
    },
    // 账户池管理 -excel上传企微账号数据
    async uploadPhoneExcel(ctx, payload = {}) {return apis.uploadPhoneExcel(payload)},
    // 清除当前登录人的 Excel 查询结果缓存
    async clearCache(ctx, payload = {}) {return apis.clearCache(payload)},
      // 下载 上传失败的数据
      async downloadFailures(ctx, payload = {}) {
          const [, res] = await to(apis.downloadFailures(payload));
          return res;
      },
      // 更新 账号状态
      async batchOnline(ctx, payload = {}) {
          const [, res] = await to(apis.batchOnline(payload));
          return res;
      },
    // 用户管理 - 录音整段上传
    async voiceBatchUpload(_ctx, payload = {}) {
      const [, res] = await to(apis.voiceBatchUpload(payload));
      return res;
    },
  },
  modules: {},
};
